<template>
    <div>
        <div class="columns">
            <div class="column between-center">
                <h4 class="title is-3" style="border: none; margin: 0; padding: 0;">Filings</h4>
                <div class="field is-grouped">
                    <p v-if="isDeleteSelectedButtonVisible" class="control">
                        <a @click.prevent="confirmCustomDelete" class="button is-danger">Delete selected</a>
                    </p>
                    <p class="control">
                        <button @click="openApplicationModal" class="button is-info" >
                            <span class="icon">
                                <i class="icm-new"></i>
                            </span>
                            <span>New</span>
                        </button>
                    </p>
                </div>
            </div>
        </div>

        <o-table
            class="is-responsive is-responsive-desktop"
            :data="filings"

            :bordered="table.bordered"
            :striped="table.striped"
            :narrowed="table.narrowed"
            :checkable="table.checkable"
            :mobile-cards="table.mobileCards"
            :paginated="table.paginated"
            :pagination-simple="table.paginationSimple"
            :per-page="table.perPage"
            :default-sort-direction="table.defaultSortDirection"
            :default-sort="table.defaultSort"

            :selected.sync="selected"
            :checked-rows="checkedRows"
            @update:checkedRows="$event => checkedRows = $event"
        >
            <template>
                <o-table-column #default="{ row }" field="type" label="Application Type" sortable>
                    {{ filingApplicationTypeNameById(row.numeric_type) }}
                </o-table-column>

                <o-table-column #default="{ row }" field="type" label="Work Types">
                    {{ row.work_types_summary }}
                </o-table-column>

                <o-table-column #default="{ row }" field="dob_job_number" label="Job #" sortable>
                    {{ row.dob_job_number }}
                </o-table-column>

                <o-table-column #default="{ row }" field="filing_status" label="Filing Status" sortable>
                    {{ statusNameById(row.filing_status) }}
                </o-table-column>

                <o-table-column #default="{ row }" field="floors" label="Floors" sortable>
                    {{ row.floors }}
                </o-table-column>

                <o-table-column #default="{ row }" field="status" label="Status" sortable>
                    {{ statusNameById(row.status) }}
                </o-table-column>

                <o-table-column #default="{ row }" label="">
                    <o-dropdown hoverable position="bottom-left" class="table-actions">
                      <template #trigger>
                        <button class="button">
                          <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                        </button>
                      </template>
                        <o-dropdown-item has-link><a @click.stop="selectApplication(row)">View</a></o-dropdown-item>
                        <o-dropdown-item has-link><a @click.stop="openApplicationModal(row)">Edit</a></o-dropdown-item>
                        <o-dropdown-item has-link><a @click.stop="$emit('task-create', 'filing', row.id)">Create Activity</a></o-dropdown-item>
                    </o-dropdown>
                </o-table-column>
            </template>

            <div slot="empty" class="has-text-centered">
                No Filings entered
            </div>
        </o-table>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isApplicationModalActive">
            <application-modal :application="selectedApplication" preselected-type="Filing"/>
        </o-modal>
    </div>
</template>

<script>
    import ApplicationModal from './../../../../components/modals/applications/Layout'
    import Application from './../../../../mixins/Application'
    import Table from '../../../../mixins/Table'
    import {mapActions, mapGetters} from 'vuex'

    export default {
        mixins: [Table, Application],

        components: {
            ApplicationModal
        },

        data() {
            return {
                type: 'filing'
            }
        },

        computed: {
            ...mapGetters({
                filingApplicationTypeNameById: 'filingApplicationTypeNameById',
                filings: 'filings/currentProjectItems'
            })
        },

        methods: {
            ...mapActions({
                removeItem: 'filings/remove'
            })
        }
    }
</script>
